import React from 'react';
import { MapIcon } from 'lucide-react';
import { images } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Hero() {
  return <header className="w-full bg-canvas px-5 pb-16 pt-8 md:pt-12" data-id="element-193" data-mp="cxxm3hachn63">
      <div className="mx-auto max-w-5xl" data-id="element-194" data-mp="hvqrw97qkf5u">
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-195" data-mp="hsl3kw6xlhb6">
          <div className="flex items-center gap-2" data-id="element-196" data-mp="mrxxu204tqns">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-sky-light" data-id="element-197" data-mp="quue3m279aok">
              <MapIcon className="h-5 w-5" aria-hidden="true" data-id="element-198" data-mp="vndrahwz63su" />
            </span>
            <span className="font-serif text-xl font-bold text-navy" data-id="element-199" data-mp="10loyekvvy07d">Ortho Treatment Map™</span>
          </div>
          <span className="rounded-full bg-sky-pale px-3 py-1 text-xs font-bold uppercase tracking-wide text-navy-700 ring-1 ring-sky-light" data-id="element-200" data-mp="15ll3yok8dzp1">
            By Dr. Nathan Brooks
          </span>
        </div>

        <h1 className="mx-auto mt-8 max-w-4xl text-center font-serif text-[38px] font-black leading-[1.08] text-navy md:text-6xl" data-id="element-201" data-mp="9oly4akoc0nw">
          Plan your next orthodontic case in{' '}
          <em className="italic text-sky" data-id="element-202" data-mp="3vu94nb28y2g9">15 minutes</em>
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-center text-xl font-bold text-navy md:text-2xl" data-id="element-203" data-mp="3rtfgqhot0nnd">
          — without guessing what to do next.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] leading-relaxed text-muted md:text-lg" data-id="element-204" data-mp="sdskc7kofaeg">
          A clearer system for turning a patient’s findings into an organized treatment plan. Includes{' '}
          <strong className="text-navy" data-id="element-205" data-mp="imeeli24tecv">6 premium volumes</strong>, <strong className="text-navy" data-id="element-206" data-mp="enp1lql09ytr">5 professional tools</strong>, and{' '}
          <strong className="text-navy" data-id="element-207" data-mp="1b4jsx6wuawrs">30+ decision protocols</strong>, checklists, treatment maps and planning worksheets.
        </p>

        <img src={images.product} alt="Ortho Treatment Map: 6 volumes, 5 bonuses and digital planning tools" className="mx-auto mt-8 w-full max-w-3xl" data-id="element-208" data-mp="16da3a6bajtfw" />

        <p className="mx-auto mt-4 max-w-xl text-center text-[17px] font-semibold leading-relaxed text-navy" data-id="element-209" data-mp="35jz074vqqscx">
          Move from <span className="text-muted" data-id="element-210" data-mp="2qvuc1ldx5omr">“What should I do with this case?”</span> to{' '}
          <span className="text-cta" data-id="element-211" data-mp="2vtw42vtboyad">“I know what to evaluate, what my objective is, and what comes next.”</span>
        </p>

        <div className="mt-8" data-id="element-212" data-mp="2hxiqvyvtnj1p">
          <CtaButton id="first-cta" label="I want the Ortho Treatment Map™" note="Immediate digital access · One-time payment of USD $27 · Lifetime access · 7-Day Guarantee" data-id="element-213" data-mp="2mu90q4h19ieo" />
          <Countdown data-id="element-214" data-mp="2cxe63wnvs25o" />
          <ScarcityBar data-id="element-215" data-mp="2cwuxx7o18s4u" />
        </div>
      </div>
    </header>;
}